import React from 'react'
import styled from 'styled-components'

import EmailSignup from 'components/form/EmailSignup'

const EmailSignupWrapper = styled.div`
  max-width: 480px;
  margin-left: auto;
  margin-right: auto;
`
interface SignupProps {
  action: string
  token: string
}

const Signup = (props: SignupProps) => {
  const { action, token } = props
  return (
    <EmailSignupWrapper>
      <EmailSignup
        action={action}
        token={token}
        appearance="raised"
        buttonLabel="Sign up"
        placeholder="Email address"
        solidButton
      />
    </EmailSignupWrapper>
  )
}

export default Signup
